import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { render } from 'react-dom';
import PermissionsCheckbox from './PermissionsCheckbox';
const permissionCheckboxes = document.getElementsByName('user-permission-checkbox');
permissionCheckboxes.forEach((permissionCheckbox) => {
    const partnerId = permissionCheckbox.hasAttribute('data-partner-id')
        ? permissionCheckbox.getAttribute('data-partner-id')
        : null;
    render(_jsx(PermissionsCheckbox, { checked: permissionCheckbox.getAttribute('data-checked') === '1', permission: permissionCheckbox.getAttribute('data-permission'), partnerId: partnerId }), permissionCheckbox);
});
